(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["obp-card-variants"] && !Shopify.designMode) return;
  try {
    class OBPCardVariants extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const pill = event.target.closest('[data-obp-cardvar-pill]');
        if (!pill || !this.contains(pill)) return;
        const card = this.closest('li.product-grid__item') || this.closest('li, article, product-card') || this;
        const pills = [...this.querySelectorAll('[data-obp-cardvar-pill]')];
        OBPCardVariants.apply(card, pills.indexOf(pill));
      });
      this.#split();
    }

    // Une case de grille par variante. Marche dans la grille de collection native
    // (li.product-grid__item) ET dans les listings custom OBP type « Voir aussi »
    // (li.obp-also__item : page univers Loire, sections obp_loire_*).
    #split() {
      if (this.dataset.obpSplit) return;
      this.dataset.obpSplit = 'done';
      const card = this.closest('li.product-grid__item') || this.closest('li.obp-also__item');
      if (!card || card.dataset.obpVariantClone) return;
      // (généralisé à TOUS les produits à ≥2 variantes le 30/07)
      const pills = [...this.querySelectorAll('[data-obp-cardvar-pill]')];
      if (pills.length < 2) return;
      OBPCardVariants.apply(card, 0);
      const clone = card.cloneNode(true);
      clone.dataset.obpVariantClone = 'true';
      clone.querySelectorAll('[id]').forEach((e) => e.removeAttribute('id'));
      card.after(clone);
      OBPCardVariants.apply(clone, 1);
    }

    static apply(card, index) {
      if (index < 0) return;
      const cv = card.querySelector('obp-card-variants') || card;
      const pills = [...cv.querySelectorAll('[data-obp-cardvar-pill]')];
      const pill = pills[index];
      if (!pill) return;
      pills.forEach((p) => p.classList.toggle('is-active', p === pill));
      const img = pill.dataset.img;
      if (img) {
        const t =
          card.querySelector('slideshow-slide:not([hidden]) img') ||
          card.querySelector('slideshow-slide img') ||
          card.querySelector('.product-media-container img') ||
          card.querySelector('img');
        if (t) { t.removeAttribute('srcset'); t.removeAttribute('sizes'); t.src = img; }
      }
      const vid = pill.dataset.variantId;
      if (vid) {
        card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
          try { const u = new URL(a.href, location.origin); u.searchParams.set('variant', vid); a.href = u.pathname + u.search; } catch (e) {}
        });
      }
      // PRIX : la carte doit afficher le prix de LA variante de la pastille (ils
      // peuvent différer : plateau Loire 37×28 = 59 € / 42×31 = 79 €). Sans ça,
      // la carte clonée hérite du prix de la 1re variante — bug signalé par
      // Mayeul le 30/07 (79 € affiché 59 € pendant plusieurs heures sur le live).
      if (pill.dataset.price) {
        card.querySelectorAll('product-price .price').forEach((el) => { el.textContent = pill.dataset.price; });
        card.querySelectorAll('product-price s').forEach((s) => {
          if (pill.dataset.compare) { s.textContent = pill.dataset.compare; } else { s.remove(); }
        });
      }
      // Survol : la 2e image de la carte = la photo de CETTE variante (jamais l'autre variante).
      // Générique : marche pour coffret, plateau, dessous de verre… (chaque pastille porte data-img = photo variante).
      const media = Array.from(card.querySelectorAll('.product-media img'));
      if (media.length > 1 && pill.dataset.img) {
        media[1].removeAttribute('srcset'); media[1].removeAttribute('sizes');
        media[1].src = pill.dataset.img;
      }
    }
  }

  if (!customElements.get('obp-card-variants')) {
    customElements.define('obp-card-variants', OBPCardVariants);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["obp-format-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('obp-format-picker')) return;
  class OBPFormatPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const card = e.target.closest('[data-obp-value]');
        if (!card) return;
        const value = card.dataset.obpValue;
        const scope = this.closest('.shopify-section') || document;
        const input = Array.from(scope.querySelectorAll('variant-picker input[type="radio"]'))
          .find((i) => i.value === value);
        if (input && !input.checked) input.click();
        this.querySelectorAll('[data-obp-value]').forEach((c) => {
          const sel = c === card;
          c.classList.toggle('is-selected', sel);
          c.setAttribute('aria-checked', sel ? 'true' : 'false');
        });
      });
    }
  }
  customElements.define('obp-format-picker', OBPFormatPicker);
})();
  } catch(e) { console.error(e); }
})();

})();
